AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Problem");

AoPS.Alcumus.Views.Problem = (function (AlcVProblem) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Ui = AoPS.Ui;
	var Feed = AoPS.Feed;
	var Flyout = AoPS.Ui.Flyout;
	var Modal = AoPS.Ui.Modal;
	var Rogb = AoPS.Rogb;
	var parseMath = AoPS.parseMath;
	var AlcUrl = AoPS.Alcumus.Url;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	var AlcVSubject = AoPS.Alcumus.Views.Subject;
	var AlcVFocus = AoPS.Alcumus.Views.Focus;

	// Helper function for problem and solution display. Returns the provided
	// model's level_data fields, augmented with subject_name and topic_name keys.
	function getAugmentedLevels(model) {
		var level_data = model.get("level_data");
		var subjects = model.get("user").get("subjects");

		return _.map(level_data, function (level_node) {
			// Attach subject name
			level_node.subject_name = subjects.get(level_node.subject_id).get("name");

			// Attach topic name
			if (model.has("topics")) {
				var topics = model.get("topics").filter(function (topic) {
					return level_node.subject_id === topic.get("subject").id;
				});
				if (topics.length) {
					level_node.topic_name = topics[0].get("name");
				}
			}

			return level_node;
		});
	}

	AlcVProblem.ProblemPage = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-problem-page");

			this.createAllSubviews();
			this.render();
		},

		createAllSubviews: function () {
			this.clearLocation("@subject_progress");
			this.subject_progress = new AlcVSubject.ProgressPanel({
				model: this.model,
			});
			this.addSubviewToLocation(this.subject_progress, "@subject_progress");

			this.clearLocation("@focus");
			this.focus = new AlcVFocus.MainPanel({
				model: this.model,
			});
			this.addSubviewToLocation(this.focus, "@focus");

			this.clearLocation("@problem_main");
			this.problem_main = new AlcVProblem.CurrentPanel({
				model: this.model,
			});
			this.addSubviewToLocation(this.problem_main, "@problem_main");
		},
	});

	// This class has two modes: displaying problem and displaying solution,
	// tracked in the this.show_solution property.
	// The ProblemDisplay and SolutionDisplay subviews raise show_solution
	// and show_problem events respectively to change the mode.
	// Pass in the user model here.
	AlcVProblem.CurrentPanel = AlcVBase.BaseView.extend({
		className: "alc-current-problem",

		initialize: function (options) {
			this.for_sp_nova = !!options.for_sp_nova;

			// Deal with full-ness
			this.full = options.full;
			this.model.set("full", this.full);
			if (this.full === false) {
				this.$el.addClass("no-float");
			}
			// No template; all it does is contain the problem/solution display view.

			var next_problem_events =
				"change:current_problem " +
				"change:displayed_solution " +
				"change:displayed_solution_error " +
				"change:displayed_solution_pending";
			this.listenTo(this.model, next_problem_events, function () {
				// If we're displaying a problem now, refresh the display for the new one.
				if (!this.show_solution) {
					this.showProblem();
				}
			});
			this.listenTo(
				this.model,
				"focus_set change:is_tutorial_active",
				this.showProblem
			);

			this.listenTo(Backbone, "alc_show_problem", this.showProblem);

			this.showProblem();
		},

		showProblem: function () {
			var curr_problem = this.model.get("current_problem");
			curr_problem.requestLoad(function (ok, data) {
				if (!ok) {
					if (this.model.get("current_problem") !== curr_problem) {
						// curr_problem switched out before load finished; do nothing.
						// (this fixes a race bug when changing focus errors out)
						return;
					}
					return this.renderError(data);
				}

				if (
					!this.show_solution &&
					this.problem_model &&
					this.model.get("is_tutorial_active") === this.show_tutorial &&
					this.problem_model.cid === this.model.get("current_problem").cid
				) {
					// No change needed
					this.render();
					return;
				}

				this.problem_model = this.model.get("current_problem");
				this.show_solution = false;

				this.createAllSubviews();
				this.render();
			}, this);

			this.renderLoading();
		},

		showSolution: function () {
			if (this.show_solution) {
				return; // No action needed
			}

			this.show_solution = true;

			this.createAllSubviews();
			this.render();
		},

		createAllSubviews: function () {
			var subview_model;

			if (this.display_subview) {
				this.stopListening(this.display_subview, "show_problem");
				this.stopListening(this.display_subview, "show_solution");
				this.display_subview.close();
			}
			// '' is the default location meaning to just append the subview inside.
			this.clearLocation("");
			this.show_tutorial = false;

			if (this.model.get("is_tutorial_active")) {
				this.display_subview = new AlcVProblem.TutorialDisplay({
					model: this.model,
				});
				this.addSubviewToLocation(this.display_subview, "");
				this.show_tutorial = true;
			} else if (this.model.get("displayed_solution_pending")) {
				// Show nothing
			} else if (this.model.get("displayed_solution_error")) {
				this.display_subview = new AlcVProblem.NotDoneProblemDisplay({
					model: this.model,
					error_code: this.model.get("displayed_solution_error"),
				});
				this.addSubviewToLocation(this.display_subview, "");
				this.listenTo(this.display_subview, "show_problem", this.showProblem);
			} else if (this.model.get("displayed_solution")) {
				subview_model = this.model.get("displayed_solution");
				this.display_subview = new AlcVProblem.SolutionDisplay({
					model: subview_model,
					for_sp_nova: this.for_sp_nova,
					is_past: true,
				});
				this.addSubviewToLocation(this.display_subview, "");
				this.listenTo(this.display_subview, "show_problem", this.showProblem);
			} else if (this.show_solution) {
				subview_model = this.problem_model.get("trial");
				this.display_subview = new AlcVProblem.SolutionDisplay({
					model: subview_model,
					for_sp_nova: this.for_sp_nova,
				});
				this.addSubviewToLocation(this.display_subview, "");
				this.listenTo(this.display_subview, "show_problem", this.showProblem);
			} else {
				subview_model = this.problem_model;
				this.display_subview = new AlcVProblem.ProblemDisplay({
					model: subview_model,
					for_sp_nova: this.for_sp_nova,
					full: this.full,
				});
				this.addSubviewToLocation(this.display_subview, "");
				this.listenTo(this.display_subview, "show_solution", this.showSolution);
			}
		},

		onAddToPage: function () {
			if (this.display_subview && this.display_subview.setMinHeight) {
				this.display_subview.setMinHeight();
			}
		},

		onRemoveFromPage: function () {
			// Next time we show the view, make it the problem.
			this.showProblem();
		},
	});

	// Pass in the trial model to be displayed.
	AlcVProblem.PastPanel = AlcVBase.BaseView.extend({
		className: "alc-past-problem",

		initialize: function (options) {
			// No template
			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.listenTo(this.model.get("user"), "focus_set", this.showProblem);

				this.createAllSubviews();
				this.render();
			}, this);
			this.renderLoading();
		},

		showProblem: function () {
			Backbone.trigger("alc_goto_url", AlcUrl.getUrl("problem"));
		},

		createAllSubviews: function () {
			var view_obj;

			this.clearLocation(""); // Default location

			view_obj = new AlcVProblem.SolutionDisplay({
				model: this.model,
				is_past: true,
			});
			this.addSubviewToLocation(view_obj, "");
		},
	});

	$(function () {
		Handlebars.registerPartial(
			"welcome-panel-content",
			compileTemplate("#alc-cms-welcome-panel-content")
		);
	});
	AlcVProblem.TutorialDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-tutorial-panel");
			this.render();
		},
	});

	AlcVProblem.NotDoneProblemDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.error_code = options.error_code;
			this.setTemplateAndUseRootEl("alc-tpl-not-done-problem-panel");
			this.render();
		},

		events: {
			"click .alc-solution-links .alc--play": "onPlay",
		},

		onPlay: function () {
			this.model.resetDisplayedSolution();
			Backbone.trigger("alc_goto_url", AlcUrl.getUrl("problem"));
		},

		getContext: function () {
			return {
				unseen: this.error_code === "E_UNSEEN_PROBLEM",
			};
		},
	});

	// This view raises a show_solution event when the solution should
	// be swapped in.
	AlcVProblem.ProblemDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.for_sp_nova = !!options.for_sp_nova;

			this.setTemplateAndUseRootEl(
				this.for_sp_nova
					? "alc-tpl-problem-display-sp-nova"
					: "alc-tpl-problem-display"
			);

			this.full = options.full;

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}
				this.model.markAsViewed();

				this.createAllSubviews();

				this.render();
				if (this.for_sp_nova) {
					this.rearrangeDivsForSpNova(true);
				}

				this.listenTo(
					this.model,
					"change",
					_.bind(function () {
						this.render();
						if (this.for_sp_nova) {
							this.rearrangeDivsForSpNova(false);
						}
					}, this)
				);
			}, this);
			this.renderLoading();
		},

		rearrangeDivsForSpNova: function () {
			// Rearrange problem view for SP flexing.
			this.novaVars = this.novaVars || {};
			if (!this.$(".nova-alcumus-header").length) {
				this.novaVars.$prefix = $("<div />").addClass(
					"nova-alcumus-header nova-alcumus-section"
				);
				this.novaVars.$prefix.append(this.$(".alc-focus-panel-bar"));
				this.novaVars.$prefixFlex = $("<div />").addClass("flex-inner");
				this.novaVars.$prefixFlex
					.append(
						this.$el
							.children()
							.not(".nova-alcumus-section")
							.not(".alc-problem-text")
					)
					.appendTo(this.novaVars.$prefix);
				_.each(this.novaVars.$prefixFlex.children(), function (el) {
					if ($(el).html().trim().length <= 0) {
						$(el).hide();
					}
				});
				this.$el.append(this.novaVars.$prefix);
			}

			if (!this.$(".aops-scroll-outer").length) {
				this.novaVars.$scrollOuter = $("<div />").addClass(
					"aops-scroll-outer nova-alcumus-section"
				);
				this.novaVars.$scrollBar = $("<div />")
					.addClass("aops-scroll-bar")
					.append($("<div />").addClass("aops-scroll-slider"))
					.appendTo(this.novaVars.$scrollOuter);
				this.novaVars.$scrollInner = $("<div />")
					.addClass("aops-scroll-inner")
					.appendTo(this.novaVars.$scrollOuter);
				this.novaVars.$scrollContent = $("<div />")
					.addClass("aops-scroll-content")
					.appendTo(this.novaVars.$scrollInner);
				$("<div />")
					.addClass("scroll-content-padding")
					.append(
						this.$el
							.children()
							.not(".nova-alcumus-section")
							.not(".alc-problem-input-bar")
					)
					.appendTo(this.novaVars.$scrollContent);
				this.$el.append(
					$("<div />")
						.addClass("nova-alcumus-expand")
						.append(this.novaVars.$scrollOuter)
				);

				AoPS.Ui.buildAopsScrollbar({
					$scrollbar: this.novaVars.$scrollBar,
					$content: this.novaVars.$scrollContent,
					show_on_hover: true,
					fade_start_class: "aops-scroll-fade-top aops-scroll-faders",
					fade_end_class: "aops-scroll-fade-bottom aops-scroll-faders",
				});
			}

			if (!this.$(".nova-alcumus-appendix").length) {
				this.novaVars.$appendixInner = this.$(".alc-problem-input-bar");
				this.novaVars.$appendixWrapper =
					this.novaVars.$appendixInner.addClass("wrapper");
				this.novaVars.$appendixActions = $("<div />")
					.addClass("actions nova-alcumus-appendix nova-alcumus-section")
					.append(this.novaVars.$appendixWrapper);

				if (
					this.novaVars.$appendixInner.find(".alc-right").length &&
					this.novaVars.$appendixInner.find(".alc--buttons").length
				) {
					this.novaVars.$appendixInner
						.find(".alc-right")
						.insertAfter(this.novaVars.$appendixInner.find(".alc--buttons"));
				}
				if (
					!this.novaVars.$appendixInner.find(".alc--main-input-outer").length
				) {
					this.novaVars.$appendixInner.prepend(
						$("<div />")
							.addClass("alc--main-input-outer")
							.append(
								this.novaVars.$appendixInner.find(".alc-problem-input-main")
							)
					);
				}
				if (
					!this.novaVars.$appendixInner.find(".nova-formatting-tips").length
				) {
					this.novaVars.$appendixInner.prepend(
						$("<div />")
							.addClass("nova-formatting-tips")
							.append(
								this.novaVars.$appendixInner
									.find(".alc--buttons .alc--formatting")
									.text("Show Formatting Tips")
							)
					);
				}
				this.$el.append(this.novaVars.$appendixActions);
			}

			Backbone.trigger("alcumus_nova_problem");
		},

		createAllSubviews: function () {
			if (this.for_sp_nova) {
				this.clearLocation("@focus_panel");
				this.focus_panel = new AlcVFocus.MainPanel({
					model: this.model.get("user"),
					bar_only: true,
				});
				this.addSubviewToLocation(this.focus_panel, "@focus_panel");
			}

			this.clearLocation("@input_bar");
			this.input_bar = new AlcVProblem.ProblemInputBar({
				model: this.model,
				parent: this,
				full: this.full,
			});
			this.addSubviewToLocation(this.input_bar, "@input_bar");

			this.clearLocation("@subject_xp");
			this.subject_xp = new AlcVProblem.SubjectXPDisplay({
				model: this.model,
			});
			this.addSubviewToLocation(this.subject_xp, "@subject_xp");

			this.clearLocation("@astat_xp");
			this.astat_xp = new AlcVProblem.AStatXPDisplay({
				model: this.model,
			});
			this.addSubviewToLocation(this.astat_xp, "@astat_xp");

			this.clearLocation("@seen_history");
			this.seen_history = new AlcVProblem.ProblemSeenHistory({
				model: this.model,
			});
			this.addSubviewToLocation(this.seen_history, "@seen_history");
		},

		events: {
			"click .alc-problem-review-info": "onReviewInfo",
			"click .alc-problem-class-new-topic": "onNewTopic",
		},

		// Method called by the input bar
		showSolution: function () {
			this.trigger("show_solution");
		},

		// Method called by the input bar
		showAdmin: function () {
			// We can use this for testing various sizes of problem text. So we'll
			// allow multiple of these to be made, and clicking one removes it.

			// if (this.admin_shown) { return; }
			// this.admin_shown = true;

			var admin_div = $(
				$.parseHTML(
					'<div style="color:red">' +
						this.model.get("admin").join("<br>") +
						"</div>"
				)
			);
			this.$(".alc-problem-text").append(admin_div);
			admin_div.click(function () {
				admin_div.remove();
			});
		},

		getContext: function () {
			var model = this.model;
			var text = model.get("problem_text");
			var master_model = this.model.get("user").get("master");

			var problemErrorTpl = compileTemplate("#alc-tpl-problem-render-error");
			if (model.get("render_error")) {
				text += problemErrorTpl({solution: false});
			}

			return {
				problem_text: text,
				is_review: model.get("is_review"),
				can_discuss: master_model.get("grid_class_id") > 0,
			};
		},

		postRender: function () {
			// Don't allow asymptote source to be seen for problems.
			this.$(".asy-image").attr("alt", "");
		},

		onReviewInfo: function () {
			var message =
				"This is a review problem. " +
				"Sometimes Alcumus will give you review problems from topics that you have already passed. " +
				"You must answer or give up on this problem before continuing.";
			Modal.showAlert(message);
		},

		onNewTopic: function () {
			var model = this.model;
			var master_model = model.get("user").get("master");
			var alcumus_url = master_model.get("grid_url_prefix") + "alcumus";
			var problem_id = model.id;
			AoPS.Feed.startNewTopic({
				category_id: master_model.get("grid_forum_id"),
				linked_tag: "Alcumus",
				target_url: alcumus_url + "/problem/" + problem_id,
				target_text: " an Alcumus problem",
				hidden_tags: [alcumus_url],
				content:
					"[quote=Alcumus]" + model.get("problem_text_bbcode") + "[/quote]",
			});
		},
	});

	function computeTipTextList(tip_data) {
		function getTip(data) {
			try {
				return Handlebars.compile($("#alc-cms-tip-" + data.text_key).html())();
			} catch (e) {
				return null;
			}
		}
		var tip_list = _.compact(_.map(tip_data, getTip));
		return tip_list.length ? tip_list : null;
	}

	AlcVProblem.SubjectXPDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-subject-xp-display");
			this.render();
		},

		getContext: function () {
			return {
				level_data: getAugmentedLevels(this.model),
			};
		},
	});

	AlcVProblem.AStatXPDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-astat-xp-display");
			this.render();
		},

		getContext: function () {
			return {
				astat_data: this.processProblemAstats(),
			};
		},

		// Helper for getContext, processing an object of code: data pairs into
		// an array of objects the context can use
		processProblemAstats: function () {
			var problem_astats = this.model.get("astats");
			var user_astats = this.model.get("user").get("astats");
			var data = _.map(problem_astats, function (astat_data, code) {
				var astat_model = user_astats.get(code);
				if (!astat_model) {
					return null;
				}
				return {
					available_xp: astat_data.xp,
					code: code,
					name: astat_model.get("name"),
					level: astat_model.get("level"),
					next_level: astat_model.get("level") + 1,
					xp_to_next: astat_model.get("xp_to_next"),
				};
			});

			// Get rid of nulls as a result of bad astat codes.
			data = _.compact(data);

			return data;
		},
	});

	AlcVProblem.ProblemSeenHistory = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-problem-seen-history");
			this.render();
		},

		getContext: function () {
			return {
				seen_before: this.model.get("seen_before"),
				solved_before: this.model.get("solved_before"),
			};
		},
	});

	AlcVProblem.ProblemInputBar = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-problem-input-bar");

			this.full = options.full;
			this.model.set("full", this.full);

			// Parent is something we can trigger show_solution events on
			this.parent = options.parent;

			this.main_input = new AlcVProblem.ProblemInputMain({model: this.model});
			this.addSubviewToLocation(this.main_input, "@input");

			// Convenience
			this.focusInputBound = _.bind(
				this.main_input.focusInput,
				this.main_input
			);

			this.listenTo(
				this.main_input,
				"change",
				_.bind(this.onChangeInput, this)
			);
			this.listenTo(
				this.main_input,
				"admin_win",
				_.bind(this.onAdminWin, this)
			);
			this.listenTo(
				this.main_input,
				"submit",
				_.bind(this.onClickSubmit, this)
			);

			this.rendered_panel = new AlcVProblem.RenderedInputPanel();
			this.addSubviewToLocation(this.rendered_panel, "@rendered");

			this.render();
		},

		events: {
			"click .alc--submit": "onClickSubmit",
			"click .alc--give-up": "onClickGiveUp",
			"click .alc--admin": "onClickAdmin",
			"click .alc--formatting": "onClickFormatting",
		},

		setAsProcessing: function (show_processing) {
			this.$(".alc--buttons div").toggleClass("disabled", !!show_processing);
			this.$(".alc--give-up").toggle(!show_processing);
			this.$(".alc--processing").toggle(!!show_processing);

			this.main_input.setDisabled(show_processing);
			this.main_input.updatePlaceholder();
			this.updateGiveUpState();
		},

		onChangeInput: function (current_input) {
			var flags = [];
			if (this.model.get("is_interval")) {
				flags.push("interval");
			}
			if (this.model.get("matrix_size")) {
				flags.push("matrix");
			}
			var result = parseMath(current_input || "", flags.join(" "));
			var has_errors = !!result.errors.length;
			this.rendered_panel.setData(current_input, result.submission, has_errors);
		},

		onClickSubmit: function () {
			if (this.show_processing) {
				return;
			}
			var response = this.main_input.getSubmitResponse();
			if (response) {
				this.setAsProcessing(true);
				this.model.submitResponse(response, this.onAjaxSubmitDone, this);
			} else {
				this.focusInputBound();
				if (this.model.get("matrix_size")) {
					Modal.showAlert(
						"Please enter a response. All fields must have values."
					);
				} else {
					Modal.showAlert("Please enter a response.");
				}
			}
		},

		onAdminWin: function () {
			if (this.show_processing) {
				return;
			}
			var admin = this.model.get("admin");
			var answer;

			if (admin && !this.show_processing) {
				_.find(admin, function (text) {
					var result = text.match(/Answer: (.*)/);
					if (result) {
						answer = result[1];
						return true;
					}
				});
				if (answer) {
					this.main_input.setResponse(answer);
					this.setAsProcessing(true);
					this.model.submitResponse(answer, this.onAjaxSubmitDone, this);
				}
			}
		},

		onClickGiveUp: function () {
			if (this.show_processing) {
				return;
			}

			if (!this.model.hasResponse()) {
				// Can't give up yet; button should be gray right now.
				AlcVBase.showModalError(
					null,
					{error_code: "E_NO_GIVEUP"},
					{
						onClose: this.focusInputBound,
					}
				);
				return;
			} else {
				Modal.showConfirm(
					"Are you sure you want to give up?",
					function (confirmed) {
						if (!confirmed) {
							return;
						}
						this.setAsProcessing(true);
						this.model.giveUp(this.onAjaxSubmitDone, this);
					}.bind(this)
				);
			}
		},

		onClickAdmin: function () {
			this.parent.showAdmin();
		},

		onClickFormatting: function () {
			if (this.show_processing) {
				return;
			}
			this.stop_tips_flashing = true;

			var tipsTpl = compileTemplate("#alc-tpl-formatting-tips");
			var modal_html = tipsTpl({
				tip_text_list: computeTipTextList(this.model.get("tip_list")),
			});

			Modal.showMessage(modal_html, {
				title: "Helpful tips",
				mathjax: true,
				scrollable: true,
				onClose: this.focusInputBound,
			});
		},

		// Used as callback for submission methods
		onAjaxSubmitDone: function (ok1, data1) {
			var message;
			var main_input = this.main_input;
			var focusInputBound = this.focusInputBound;
			var result = data1.result;

			this.setAsProcessing(false);
			if (!ok1 && data1.error_code === "E_PARSER" && data1.error_msg) {
				Modal.showAlert(data1.error_msg);
			} else if (!ok1) {
				main_input.blurInput();
				AlcVBase.showModalError(
					"An error occurred when submitting your answer.",
					data1,
					{
						onClose: focusInputBound,
					}
				);
			} else if (result === "U") {
				main_input.blurInput();
				message =
					"Your answer is incorrect, but you still have another shot " +
					"at this problem. Check your work carefully and try again.";
				Modal.showAlert(message, {
					onClose: function () {
						main_input.setResponse("");
						focusInputBound();
					},
				});
			} else {
				this.parent.showSolution();
				this.model.finish(
					data1.next_problem,
					function (ok2, data2) {
						if (!ok2) {
							message =
								"An error occurred when Alcumus tried to advance you " +
								"to your next problem.";
							data2.should_refresh = true;
							AlcVBase.showModalError(message, data2);
						}
					},
					this
				);
			}
		},

		updateGiveUpState: function () {
			var giveup_button = this.$(".alc--give-up");
			if (this.show_processing) {
				giveup_button.addClass("disabled");
				giveup_button.removeAttr("title");
			} else if (!this.model.hasResponse()) {
				giveup_button.addClass("disabled");
				giveup_button.attr(
					"title",
					"You can't give up on problems you haven't attempted."
				);
			} else {
				giveup_button.removeClass("disabled");
				giveup_button.removeAttr("title");
			}
			// Reverse the CSS rule disabling all pointer events on disabled buttons
			giveup_button.css("pointer-events", "auto");
		},

		flashTipsButton: function () {
			var iterations = 8;
			var anim_time = 600;
			var period = 1500;
			var flash_color = "#F00";

			var button = this.$(".alc--formatting");
			var orig_color = button.css("color");
			function flash() {
				button.animate({color: flash_color}, anim_time);
			}
			function unflash() {
				button.animate({color: orig_color}, anim_time);
			}

			var doIteration = _.bind(function () {
				// Make sure we're still animating, still in the DOM, and
				// that the user hasn't clicked the button.
				if (!iterations || !button.width() || this.stop_tips_flashing) {
					iterations = 0;
					return;
				}
				iterations -= 1;

				flash();
				setTimeout(unflash, anim_time + 10);
				setTimeout(doIteration, period);
			}, this);

			setTimeout(function () {
				// Usually takes a little while to get in the DOM, so recompute
				// the orig_color.
				orig_color = button.css("color");
				doIteration();
			}, 100);
		},

		getContext: function () {
			return {
				matrix_size: this.model.get("matrix_size"),
			};
		},

		postRender: function () {
			if (!this.model.get("admin")) {
				this.$(".alc--admin").hide();
			}

			if (!this.model.get("tip_list").length) {
				this.$(".alc--formatting").hide();
			} else {
				this.flashTipsButton();
			}

			this.$(".alc--processing").append(AoPS.Page.$loader.clone());

			this.setAsProcessing(false);
			this.updateGiveUpState();
		},
	});

	AlcVProblem.ProblemInputMain = AlcVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("alc-tpl-problem-input-main");

			this.render();
		},

		// Returns the entered response as a string. For matrices, returns a string
		// containing [[a1, a2, ...], [b1, b2, ...], ...] if more than one column,
		// else just returns [a1, b1, ...]. The response will be valid JSON if it
		// is a matrix.
		getResponse: function () {
			var matrix_size = this.model.get("matrix_size");
			if (!matrix_size) {
				return this.problem_inputs.val();
			} else {
				var response_array = [];
				for (var y = 0; y < matrix_size[0]; y += 1) {
					var row = [];
					var row_el = this.$(".alc--matrix-row[data-row='" + y + "']");
					for (var x = 0; x < matrix_size[1]; x += 1) {
						var input_el = row_el.find("input[data-column='" + x + "']");
						var val = input_el.val();
						if (!val) {
							return "";
						}
						val = val.trim();
						if (/\-[0-9]*\.?[0-9]*/.test(val)) {
							val = val.replace(/"/g, "");
						}
						row.push(val);
					}
					response_array.push(matrix_size[1] === 1 ? row[0] : row);
				}
				return JSON.stringify(response_array);
			}
		},

		// Does a bit more extra processing beyond getResponse for sending to the
		// backend. getResponse is better for things like parseMath.
		getSubmitResponse: function () {
			return this.getResponse().replace(/"/g, "").trim();
		},

		// Passing a falsy value clears the response. Uses the same format as
		// getResponse.
		setResponse: function (val) {
			var matrix_size = this.model.get("matrix_size");
			if (!val) {
				this.$(".alc--main-input").val("");
			} else if (!matrix_size) {
				this.problem_inputs.val(val || "");
			}
			// Non-falsy val arguments are currently only used for admin things, so
			// we're skipping doing anything for matrix answers for now.
		},

		focusInput: function () {
			// Mobile devices bring up keyboards when you focus; so we don't want to
			// do it then. We'll pretend to detect those by looking for small widths.
			if (window.innerWidth <= 1024) {
				return;
			}
			this.problem_inputs.first().focus();
		},

		blurInput: function () {
			this.problem_inputs.blur();
		},

		setDisabled: function (new_val) {
			if (!this.problem_inputs) {
				// Do nothing
			} else if (new_val) {
				this.problem_inputs.attr("disabled", 1);
			} else {
				this.problem_inputs.removeAttr("disabled");
			}
		},

		updatePlaceholder: function () {
			var problem_inputs = this.problem_inputs;
			var user_responses = this.model.get("user_responses");
			if (this.model.get("matrix_size")) {
				problem_inputs.attr("placeholder", "");
			} else {
				if (user_responses.length === 1) {
					problem_inputs.attr(
						"placeholder",
						"Your first answer: " + user_responses[0]
					);
				} else if (user_responses.length) {
					problem_inputs.attr(
						"placeholder",
						"Your answers: " + user_responses.join(", ")
					);
				} else {
					problem_inputs.attr("placeholder", "Enter your answer");
				}
			}
		},

		bindInputEvents: function () {
			var problem_inputs = this.$(".alc--main-input");
			this.problem_inputs = problem_inputs;

			var current_text = this.getResponse();
			problem_inputs.on(
				"input change keydown keyup cut paste",
				_.bind(function (evt) {
					var new_text = this.getResponse();
					if (new_text !== current_text) {
						current_text = new_text;
						this.trigger("change", current_text);
					}
				}, this)
			);

			AlcVBase.bindEnterKey(
				problem_inputs,
				function () {
					this.trigger("admin_win");
				},
				this,
				{with_ctrl: true}
			);
			AlcVBase.bindEnterKey(
				problem_inputs,
				function () {
					this.trigger("submit");
				},
				this
			);
		},

		getContext: function () {
			var matrix_size = this.model.get("matrix_size");
			return {
				is_matrix: !!matrix_size,
				row_indices: matrix_size && _.range(matrix_size[0]),
				column_indices: matrix_size && _.range(matrix_size[1]),
			};
		},

		postRender: function () {
			this.bindInputEvents();
			this.updatePlaceholder();

			setTimeout(_.bind(this.focusInput, this), 200);
		},
	});

	AlcVProblem.RenderedInputPanel = AlcVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("alc-tpl-problem-rendered-input-panel");

			this.rendered_input = "";
			this.has_errors = false;

			this.debouncedRender = _.debounce(_.bind(this.render, this), 500);

			this.render();
		},

		shouldRender: function (original, rendered) {
			original = original || "";
			rendered = rendered || "";
			if (/[\\\^_]/.test(original)) {
				return true;
			}

			var clean_original = original.replace(/[\s\$]/g, "");
			var clean_rendered = rendered.replace(/[\s\$]/g, "");
			if (clean_original !== clean_rendered) {
				return true;
			}
			return false;
		},

		setData: function (original_input, rendered_input, has_errors) {
			if (!this.shouldRender(original_input, rendered_input)) {
				this.rendered_input = "";
				this.has_errors = false;
			} else {
				this.rendered_input = rendered_input;
				this.has_errors = has_errors;
			}
			this.debouncedRender();
		},

		getContext: function () {
			return {
				rendered_input: "\\(" + this.rendered_input + "\\)",
			};
		},

		postRender: function () {
			var should_show = !!this.rendered_input.length;
			this.$el.toggleClass("alc--render-errors", !!this.has_errors);
			this.$el.toggle(should_show);
			if (should_show) {
				this.processMathJax();
				this.$el.css("top", -1 * this.$el.outerHeight() + "px");
				this.$el.css("left", 0);
				this.$el.draggable({containment: ".alc-problem-panel"});
			}
		},
	});

	AlcVProblem.SolutionDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.for_sp_nova = options.for_sp_nova;

			this.setTemplateAndUseRootEl(
				this.for_sp_nova
					? "alc-tpl-solution-display-sp-nova"
					: "alc-tpl-solution-display"
			);

			this.is_past = !!options.is_past;
			this.admin_view = !!options.admin_view;

			this.model.requestLoad(function (ok, data) {
				this.createAllSubviews();
				this.render();
				if (this.for_sp_nova) {
					this.rearrangeDivsForSpNova();
				}
			}, this);

			this.renderLoading();
		},

		rearrangeDivsForSpNova: function () {
			// Rearrange solution view for SP flexing.
			this.novaVars = this.novaVars || {};
			this.novaVars.$scrollOuter = $("<div />").addClass("aops-scroll-outer");
			this.novaVars.$scrollBar = $("<div />")
				.addClass("aops-scroll-bar")
				.append($("<div />").addClass("aops-scroll-slider"))
				.appendTo(this.novaVars.$scrollOuter);
			this.novaVars.$scrollInner = $("<div />")
				.addClass("aops-scroll-inner")
				.appendTo(this.novaVars.$scrollOuter);
			this.novaVars.$scrollContent = $("<div />")
				.addClass("aops-scroll-content")
				.appendTo(this.novaVars.$scrollInner);

			this.novaVars.$prefix = $("<div />")
				.addClass("nova-alcumus-header")
				.append(this.$(".alc-focus-panel-bar"));

			this.novaVars.$appendixInner = this.$(".alc-solution-links");
			this.novaVars.$appendixWrapper =
				this.novaVars.$appendixInner.addClass("wrapper");
			this.novaVars.$appendixActions = $("<div />")
				.addClass("actions")
				.append(this.novaVars.$appendixWrapper);

			this.novaVars.$appendixInner.find(".btn").addClass("grid-btn");
			this.novaVars.$appendixInner
				.find(".btn.alc--next")
				.text("New Problem")
				.prependTo(this.novaVars.$appendixInner);

			$("<div />")
				.addClass("scroll-content-padding")
				.append(this.$el.children().not(this.novaVars.$appendixInner))
				.appendTo(this.novaVars.$scrollContent);

			this.$el
				.append(this.novaVars.$prefix)
				.append(
					$("<div />")
						.addClass("nova-alcumus-expand")
						.append(this.novaVars.$scrollOuter)
				)
				.append(this.novaVars.$appendixActions);

			AoPS.Ui.buildAopsScrollbar({
				$scrollbar: this.novaVars.$scrollBar,
				$content: this.novaVars.$scrollContent,
				show_on_hover: true,
				fade_start_class: "aops-scroll-fade-top aops-scroll-faders",
				fade_end_class: "aops-scroll-fade-bottom aops-scroll-faders",
			});
			Backbone.trigger("alcumus_nova_solution");
		},

		createAllSubviews: function () {
			if (this.for_sp_nova) {
				this.clearLocation("@focus_panel");
				this.focus_panel = new AlcVFocus.MainPanel({
					model: this.model.get("user"),
					bar_only: true,
				});
				this.addSubviewToLocation(this.focus_panel, "@focus_panel");
			}

			if (this.for_sp_nova) {
				this.main_panel = new AlcVProblem.SolutionContent({
					model: this.model,
					is_past: this.is_past,
				});
			} else {
				this.main_panel = new AlcVProblem.SolutionMainPanel({
					model: this.model,
					is_past: this.is_past,
				});
			}
			this.addSubviewToLocation(this.main_panel, "@main_panel");

			this.reading_panel = new AlcVProblem.SolutionReadingPanel({
				model: this.model,
			});
			this.vote_panel = new AlcVProblem.SolutionVotesPanel({
				model: this.model,
			});
			this.addSubviewToLocation(this.reading_panel, "@aux_panels");
			this.addSubviewToLocation(this.vote_panel, "@aux_panels");

			this.solution_links = new AlcVProblem.SolutionLinks({
				model: this.model,
				is_past: this.is_past,
			});
			this.addSubviewToLocation(this.solution_links, "@links");
			this.listenTo(
				this.solution_links,
				"show_problem",
				_.bind(function () {
					this.trigger("show_problem");
				}, this)
			);
		},

		events: {
			"click .alc-solution-links .alc--play": "onPlay",
		},

		onPlay: function () {
			this.model.get("user").resetDisplayedSolution();
			Backbone.trigger("alc_goto_url", AlcUrl.getUrl("problem"));
		},

		getContext: function () {
			return _.extend(
				{},
				{
					problem_id: this.model.get("problem_id"),
					is_past: this.is_past,
					invalid_reason: this.admin_view && this.model.get("invalid_reason"),
				},
				getResultContext(this.model)
			);
		},
	});

	// Used above in SolutionDisplay and below in SolutionMainPanel.
	function getResultContext(model) {
		var result = model.get("result");
		var user_responses = model.get("user_responses");
		var result_class = Rogb.getClassFromResult(result, user_responses.length);
		var result_text = "Correct! Way to go!";
		var result_text_small = "Correct!";
		if (result === "N") {
			result_text = "Incorrect. Oops!";
			result_text_small = "Incorrect.";
		} else if (result === "G") {
			result_text = "You gave up on this problem.";
			result_text_small = "Gave up.";
		}

		var context = {
			result_text: result_text,
			result_text_small: result_text_small,
			result_class: result_class,
		};
		return context;
	}

	AlcVProblem.SolutionMainPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-solution-panel");
			this.is_past = !!options.is_past;
			this.createAllSubviews();
			this.render();
		},

		createAllSubviews: function () {
			this.clearLocation("@content");
			this.content = new AlcVProblem.SolutionContent({
				model: this.model,
				is_past: this.is_past,
			});
			this.addSubviewToLocation(this.content, "@content");

			this.clearLocation("@subject_xp");
			this.subject_xp = new AlcVProblem.SubjectXPDisplay({
				model: this.model,
			});
			this.addSubviewToLocation(this.subject_xp, "@subject_xp");
		},

		getContext: function () {
			var model = this.model;
			var main_topic = model.getMainTopic();
			var other_topics = model.get("topics").without(main_topic);
			var getTopicData = function (topic) {
				return {
					topic_name: topic.get("name"),
					subject_name: topic.get("subject").get("name"),
				};
			};

			var context = _.extend(
				{},
				{
					is_past: this.is_past,
					main_topic: main_topic && getTopicData(main_topic),
					other_topics: _.map(other_topics, getTopicData),
					sources: model.get("sources").join(", "),
				},
				getResultContext(model)
			);
			return context;
		},
	});

	AlcVProblem.SolutionContent = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-solution-content");
			this.is_past = !!options.is_past;
			this.render();
		},

		getContext: function () {
			var model = this.model;
			var problemErrorTpl = compileTemplate("#alc-tpl-problem-render-error");

			var problem_text = model.get("problem_text");
			if (model.get("render_error")) {
				problem_text += problemErrorTpl({solution: true});
			}

			var is_assigned = model.get("is_current") && this.is_past;

			var solutions = model.get("solutions");
			var solution_list = _.map(solutions, function (text, ind) {
				var heading = "Solution";
				heading += solutions.length > 1 ? " " + (ind + 1) : "";
				return {
					heading: heading,
					formatted_text: text,
				};
			});

			var user_responses = model.get("user_responses");
			var last_response = "";
			var first_response = "";
			if (user_responses.length > 1) {
				last_response = user_responses[user_responses.length - 1];
				first_response = user_responses[0];
			} else if (user_responses.length > 0) {
				last_response = user_responses[0];
			}
			first_response = first_response.replace(/^giveup$/, "give up");
			last_response = last_response.replace(/^giveup$/, "give up");

			var result = model.get("result");
			var result_class = Rogb.getClassFromResult(result, user_responses.length);

			var context = {
				problem_text: problem_text,
				last_response: last_response,
				result_class: result_class,
				first_result_class: Rogb.getClassFromResult("N"),
				first_response: first_response,
				solution_list: solution_list,
				is_assigned: is_assigned,
			};
			return context;
		},
	});

	AlcVProblem.SolutionLinks = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-solution-links");
			this.is_past = !!options.is_past;

			this.setupHotkey();
			this.render();
		},

		events: {
			"click .alc--admin": "showAdmin",
			"click .alc--play": "onPlay",
			"click .alc--next": "onNextProblem",
			"click .alc--report-bug": "onReportBug",
			"click .alc--discuss": "onDiscuss",
			"click .alc--edit": "onEdit",
		},

		setupHotkey: function () {
			setTimeout(
				_.bind(function () {
					if (!this.hotkeyHandler && !this.unbound_hotkey) {
						this.hotkeyHandler = AlcVBase.bindEnterKey(
							$(document),
							this.onNextProblem,
							this
						);
					}
				}, this),
				600
			);
		},

		unbindHotkey: function () {
			if (this.hotkeyHandler) {
				$(document).off("keypress", this.hotkeyHandler);
				delete this.hotkeyHandler;
			}
			this.unbound_hotkey = true;
		},

		showAdmin: function () {
			var admin_div = $(
				$.parseHTML(
					'<div style="color:red">' +
						this.model.get("admin").join("<br>") +
						"</div>"
				)
			);
			this.$(".alc-problem-text").append(admin_div);
			admin_div.click(function () {
				admin_div.remove();
			});
		},

		onEdit: function () {
			var url = AlcUrl.getUrl("admin_problem", this.model.get("problem_id"));
			Backbone.trigger("alc_goto_url", url);
		},

		onDiscuss: function () {
			// this.$('.alc--discuss').css('display', 'none');

			// data is a topic_id. This may return almost immediately if the topic
			// already exists and was loaded by the back-end.
			this.model.discuss(function (ok, data) {
				if (!ok) {
					this.$(".alc--discuss").css("display", "inline-block");
					AlcVBase.showModalError(
						"An error occurred with finding the community topic for this problem.",
						data
					);
					return;
				}

				if (Feed) {
					Feed.openTopic(data.topic_id);
				}
			}, this);
		},

		onReportBug: function () {
			var modalTpl = compileTemplate("#alc-cms-modal-report-bug");
			var el = $(
				$.parseHTML(
					modalTpl({
						is_in_grid: !!this.model
							.get("user")
							.get("master")
							.get("grid_url_prefix"),
					})
				)
			);
			var textarea = el.find("textarea");

			var onSubmit = _.bind(function (ok, data) {
				if (!ok) {
					this.$(".alc--report-bug").css("display", "inline-block");
					AlcVBase.showModalError(
						"An error occurred when trying to submit your bug report.",
						data
					);
					return;
				} else {
					Flyout.queue("Your bug report has been submitted.", {
						class: "info",
						time: 5500,
						animation_time: 300,
					});
				}
			}, this);

			var onModalClose = _.bind(function (value) {
				if (value !== "go") {
					return;
				}
				var val = textarea.val().trim();
				if (!val) {
					return;
				}
				this.model.submitBug(val, onSubmit);
				this.$(".alc--report-bug").css("display", "none");
			}, this);

			Modal.showButtons(
				el,
				[
					{text: "Submit", value: "go"},
					{text: "Cancel", value: "cancel"},
				],
				onModalClose,
				{
					title: "Report Bug",
				}
			);
			Ui.autoExpandTextarea(textarea);
		},

		onNextProblem: function (evt) {
			// This can be generated by a click or enter key press; don't want default
			// behavior for either.
			evt.preventDefault();

			this.trigger("show_problem");
			this.model.get("user").trigger("show_problem");
			this.unbindHotkey();
		},

		onPlay: function () {
			Backbone.trigger("alc_goto_url", AlcUrl.getUrl("problem"));
		},

		getContext: function () {
			var is_assigned = this.model.get("is_current") && this.is_past;
			return {
				is_assigned: is_assigned,
				is_admin: this.model.get("user").get("is_admin"),
				is_limited: this.model.get("user").get("limited_access"),
				is_past: this.is_past,
			};
		},

		onClose: function () {
			this.unbindHotkey();
		},
	});

	AlcVProblem.SolutionReadingPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-solution-reading-panel");
			this.render();
		},

		getContext: function () {
			var master = this.model.get("user").get("master");
			var grid_url_prefix = master.get("grid_url_prefix");

			var readings = _.map(this.model.get("readings"), function (node) {
				var url = "/store/book/" + node.store_product_sku;
				var use_stay = false;

				var book_id = parseInt(node.ebooks_book_id, 10);
				var url_suffix = node.ebooks_fragment_code
					? "/" + node.ebooks_fragment_code
					: "";
				if (book_id && _.indexOf(master.get("grid_ebook_ids"), book_id) > -1) {
					url = grid_url_prefix + "ebook/" + node.ebooks_store_sku + url_suffix;
					use_stay = true;
				} else if (grid_url_prefix) {
					url = "";
				} else if (book_id) {
					url = "/ebooks/" + node.ebooks_store_sku + url_suffix;
				}

				return {
					text: node.name + " - " + node.section,
					url: url,
					stay_attr: use_stay ? AoPS.pushState_attr : "",
				};
			});

			var videos = _.map(this.model.get("videos"), function (node) {
				var video_id = node.video_id;
				var url =
					"/videos/" +
					node.book +
					"/chapter" +
					node.chapter_number +
					"/" +
					video_id;
				var use_stay = false;

				var grid_video_ids = master.get("grid_video_ids");
				var grid_week = grid_video_ids && grid_video_ids[video_id];
				if (video_id && !_.isUndefined(grid_week)) {
					url = grid_url_prefix + "video/" + grid_week + "/" + video_id;
					use_stay = true;
				} else if (grid_url_prefix) {
					url = "";
				}

				return {
					text: node.name,
					url: url,
					stay_attr: use_stay ? AoPS.pushState_attr : "",
				};
			});

			var context = {
				readings: readings,
				videos: videos,
				has_none: !(readings.length || videos.length),
			};
			return context;
		},
	});

	AlcVProblem.SolutionVotesPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-solution-votes-panel");

			_.each(
				this.model.get("votes_asked"),
				function (question) {
					// _.each(['challenging', 'novelty', 'category'], function (question) {
					// Make sure this is a valid question name.
					if (!this.model.votes_questions[question]) {
						return;
					}

					var view_obj = new AlcVProblem.SolutionVotesQuestion({
						model: this.model,
						question: question,
					});
					this.addSubviewToLocation(view_obj, "@questions");
				},
				this
			);

			this.render();
		},
	});

	// In addition to trial model, pass a string for the question option. The
	// string should be a key of the trial models' votes_questions object.
	AlcVProblem.SolutionVotesQuestion = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-solution-votes-question");

			this.question = options.question;

			this.vote_widget = new AlcVProblem.SolutionVotesWidget({choices: 5});
			this.listenTo(this.vote_widget, "value_leave", this.onWidgetLeave);
			this.listenTo(this.vote_widget, "value_hover", this.onWidgetHover);
			this.listenTo(this.vote_widget, "value_select", this.onWidgetSelect);
			this.addSubviewToLocation(this.vote_widget, "@vote_widget");

			this.listenTo(this.model, "change:votes_data", function () {
				this.setValue(this.model.get("votes_data")[this.question] || 0);
			});
			this.setValue(this.model.get("votes_data")[this.question] || 0);

			this.render();
		},

		events: {
			"mousemove .alc-solution-votes-widget": "onHoverOver",
			"mousewheel .alc-solution-votes-widget": "onHoverLeave",
			"mouseleave .alc-solution-votes-widget": "onHoverLeave",
		},

		getContext: function () {
			var question_data = this.model.votes_questions[this.question];
			return {
				label: question_data.label,
				description: question_data.description,
			};
		},

		postRender: function () {
			this.$(".alc-custom-tooltip").hide();
			this.vote_widget.setValue(this.curr_value);
			this.updateChoiceLabel(this.curr_value);
		},

		onHoverOver: function (evt) {
			this.$(".alc-custom-tooltip").show();
			// // Don't count the tooltip as hovering over
			// var should_show = !$(evt.target).hasClass('alc-custom-tooltip');
			// this.$('.alc-custom-tooltip').toggle(should_show);
		},

		onHoverLeave: function () {
			this.$(".alc-custom-tooltip").hide();
		},

		onWidgetLeave: function () {
			this.updateChoiceLabel(this.curr_value);
		},

		onWidgetHover: function (value) {
			this.updateChoiceLabel(value, true);
		},

		onWidgetSelect: function (value) {
			var old_value = this.curr_value;
			this.curr_value = value;
			this.updateChoiceLabel(value);

			this.model.setUserVote(
				this.question,
				value,
				function (ok, data) {
					if (!ok) {
						this.setValue(old_value);
						AlcVBase.showModalError("Your rating failed to submit.", data);
					}
				},
				this
			);
		},

		setValue: function (value) {
			if (this.curr_value === value) {
				return;
			}
			this.curr_value = value;
			this.vote_widget.setValue(value);
			this.updateChoiceLabel(value);
		},

		updateChoiceLabel: function (value, is_hover) {
			var question_data = this.model.votes_questions[this.question];
			var new_label = "&nbsp;";
			if (value === 0) {
				new_label = is_hover ? "Cancel vote" : "&nbsp;";
			} else {
				new_label = question_data.choice_labels[value - 1] || "&nbsp;";
			}
			this.$(".alc--choice-label").html(new_label);
		},
	});

	// Raises three custom events:
	// value_hover (value). Value being hovered over by mouse.
	// value_leave (). Signifies that the mouse is no longer hovering over any value.
	// value_select (value). Value selected by a mouse click.
	AlcVProblem.SolutionVotesWidget = AlcVBase.BaseView.extend({
		initialize: function (options) {
			// No template
			this.$el.addClass("alc-solution-votes-widget");

			this.choices = options.choices || 5;
			this.value = options.value || 0;
			this.render();
		},

		// Should call once and not have to call again
		render: function (value) {
			this.cancel_div = $("<div></div>").addClass("alc-solution-votes-cancel");
			this.$el.append(this.cancel_div);

			var choice_base = $("<div></div>").addClass("alc-solution-votes-choice");
			var choice;
			this.choice_divs = [];
			for (var i = 1; i <= this.choices; i += 1) {
				choice = choice_base.clone().attr("data-value", i);
				this.choice_divs.push(choice);
				this.$el.append(choice);
			}

			this.setValue(this.value);
			this.trigger("value_select", this.value);
		},

		events: {
			mouseleave: "onLeave",
			"mouseover .alc-solution-votes-choice": "onHover",
			"mouseover .alc-solution-votes-cancel": "onHover",
			"click .alc-solution-votes-cancel": "onSelect",
			"click .alc-solution-votes-choice": "onSelect",
		},

		onLeave: function () {
			this.setActiveChoiceDivs(this.value);
			this.trigger("value_leave");
		},

		onHover: function (evt) {
			var value = this.getTargetValue(evt);
			this.setActiveChoiceDivs(value, true);
			this.trigger("value_hover", value);
		},

		onSelect: function (evt) {
			var value = this.getTargetValue(evt);
			this.setValue(value);
			this.trigger("value_select", value);
		},

		setValue: function (new_value) {
			new_value = new_value || 0;
			this.value = new_value;
			this.setCancelVis(!!new_value);
			this.setActiveChoiceDivs(new_value);
		},

		setActiveChoiceDivs: function (amount, is_hover) {
			var active_class = is_hover ? "alc--hover" : "alc--active";
			_.each(this.choice_divs, function (choice_div, i) {
				choice_div.removeClass("alc--hover alc--active");
				if (i < amount) {
					choice_div.addClass(active_class);
				}
			});
		},

		setCancelVis: function (should_show) {
			this.cancel_div.css("display", should_show ? "inline-block" : "none");
		},

		// Helper for event handlers
		getTargetValue: function (evt) {
			var div = $(evt.currentTarget);
			return div.hasClass("alc-solution-votes-cancel")
				? 0
				: parseInt(div.attr("data-value"), 10);
		},
	});

	return AlcVProblem;
})(AoPS.Alcumus.Views.Problem);
